<app-lms-modal-frame [title]="'Biometric Authentication'" [pageHeadWidth]="500">
  <div modal-body>
      <div *ngIf="canShowProcessModeToggle" class="mode-toggle-wrap">
        <label  class="mode-toggle-label" for="processType"> Login in as </label>
          <mdb-select class="select table-control" #processType id="processType" required
            placeholder="Login as *" aria-disabled="false"
            [(ngModel)]="selectedProcessMode" [ngModelOptions]="{standalone: true}"
            required aria-required="true" aria-haspopup="listbox"
            [class.is-valid]="selectedProcessMode !== null"
            [class.is-invalid]="selectedProcessMode === null"
            aria-expanded="false" role="combobox">
              <mdb-option [value]="'desktop'"> Desktop </mdb-option>
              <mdb-option [value]="'field'"> Tablet </mdb-option>
          </mdb-select>
      <!--<label class="mode-toggle-label">Processing Mode</label>
       <div class="btn-group" role="group" aria-label="Processing mode selection">
        <input
          type="radio"
          class="btn-check"
          name="process-mode"
          id="mode-desktop"
          [checked]="selectedProcessMode === 'desktop'"
          (change)="selectedProcessMode = 'desktop'"
        />
        <label class="btn btn-sm" for="mode-desktop"> Branch </label>

        <input
          type="radio"
          class="btn-check"
          name="process-mode"
          id="mode-field"
          [checked]="selectedProcessMode === 'field'"
          (change)="selectedProcessMode = 'field'"
        />
        <label class="btn btn-sm" for="mode-field"> Field Agent </label>
      </div> -->
    </div>

    <h5>Please Scan Finger</h5>

    <div id="scores" class="scores">
      <div class="scan-quality-wrap">
        <h5>Scan Quality</h5>
        <input class="form-control fs-7 text-center" type="text" id="qualityInputBox" readonly
          [(ngModel)]="readQuality" style="background-color:#DCDCDC;">

        <div *ngIf="showTimer" class="count-down-timer">
          <div class="example-section">
            <div class="times">
              <p> {{ display }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="content-capture" [style.display]="showStatus ? 'block' : 'none'">
      <div id="status"></div>
      <div id="imagediv"></div>
    </div>
    <div *ngIf="showTimer">
      <div *ngFor="let data of sampleData.slice(0,4); let sampleDataIndex = index;" class="px-2">
        <label class="mt-1" [for]="'sampleData' + sampleDataIndex"><small>Finger Data {{ sampleDataIndex + 1}}</small>
        </label>
        <label sampleDataIndex><small>Captured success</small></label>
      </div>
    </div>
  </div>
  <div modal-actions class="flex-container">
    <button type="button" class="btn btn-primary me-3" [disabled]="startAcquisitionDisabled"
      (click)="startCapture();showStatus=true;">Start</button>
    <button type="button" *ngIf="!environmentCheck" class="btn btn-secondary ms-4" (click)="close()">Close</button>
  </div>
</app-lms-modal-frame>
